import { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

function LineChart() {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (chartInstance.current) {
          chartInstance.current.destroy(); // Destruir gráfico
        }
    
        const ctx = chartRef.current.getContext('2d');
    
        chartInstance.current = new Chart(ctx, {
          type: 'line',
          data: {
            labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio'],
            datasets: [{
              label: 'Ventas',
              data: [65, 59, 80, 81, 56, 55],
              fill: false,
              borderColor: '#31d4be',
              tension: 0.1
            }]
          },
          options: {
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }
        });

        return () => {
            if (chartInstance.current) {
              chartInstance.current.destroy();
            }
        };
    }, []);

    return (
      <canvas style={{width: '100%'}} ref={chartRef}></canvas>
    )
};

export default LineChart;